import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';

export const SeparatorX = styled(Flex)`
  width: 100%;
  height: 1px;
  background: ${toColorString(color.opacity.charcoal15)};
`;
